export default __webpack_public_path__ + "static/media/ovary_plot.a2fa8743.png";